'use strict';
import { throttle } from '../utils';

function controller (
    $rootScope,
    $window,
    $timeout,
    $attrs,
    $cookies,
    viewport,
    localStorageService,
    sessionStorageService,
    modalService,
    consumerProfileService,
    pageStateService,
    historyStateService
) {
    const ctrl = this;
    const DO_NOT_SHOW_EXPIRE_DAYS = 90;

    ctrl.$onInit = onInit;
    ctrl.submitForm = submitForm;
    ctrl.doNotShowAgain = doNotShowAgain;
    ctrl.trackingName = 'vdp-abandon-capture-modal';
    ctrl.abandonModalId = 'vdp-abandon-capture-modal';
    ctrl.successModalId = 'vdp-email-success-modal';
    ctrl.errorModalId = 'vdp-email-error-modal';
    ctrl.eventCaptured = false;
    ctrl.formSubmitting = false;
    ctrl.formSubmitted = false;
    ctrl.isTestActive = false;

    function onInit() {
        pageStateService.set('page.attributes.abTesting', ctrl.trackingName, false);

        if (sessionStorageService.getItem('vdpEmailAlertsOptIn') === 'true'
            || $cookies.get('vdpAbandonDoNotShow') === 'true'
            || sessionStorageService.getItem('vdpAbandonDoNotShow') === 'true'
            || location.search.indexOf('vdpAbandonDoNotShow') > -1) {
                ctrl.eventCaptured = true;
                $rootScope.$emit('abandonPageCaptured');
        } else {
            $rootScope.$on('abandonPageCaptureCancel', cancelCapture);
            ctrl.userEmail = getUserEmail();

            ctrl.throttledHandler = throttle(setTimer, 1000);
            ctrl.inputEvents = [
                'mousemove',
                'mouseleave',
                'scroll',
                'input',
                'focusout',
                'touchmove'
            ];
            ctrl.inputEvents.forEach(event => $window.addEventListener(event, ctrl.throttledHandler));

            setTimer();
        }
    }

    function doNotShowAgain() {
        let expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + DO_NOT_SHOW_EXPIRE_DAYS);

        $cookies.put('vdpAbandonDoNotShow', true, {expires: expireDate, path:'/vehicledetail/detail/'});

        modalService.get(ctrl.abandonModalId).close();
    }

    function submitForm(form) {
        if (form.$valid) {
            ctrl.formSubmitting = true;
            ctrl.userEmail = form.email.$viewValue;
            localStorageService.setItem('cars.alertEmail', ctrl.userEmail);
            let params = buildSaveSearchParams();

            return consumerProfileService.saveSearchOrAlert(params)
                .then(saveAlertSuccess)
                .catch(saveAlertError);
        }
    }

    function saveAlertSuccess() {
        modalService.get(ctrl.successModalId).open();
        ctrl.formSubmitted = true;
        ctrl.formSubmitting = false;
        sessionStorageService.setItem('vdpEmailAlertsOptIn', 'true');
        pageStateService.push('event', {eventName: 'abandon-alert-create-save'}, false);
    }

    function saveAlertError() {
        modalService.get(ctrl.errorModalId).open();
        ctrl.formSubmitted = true;
        ctrl.formSubmitting = false;
    }

    function buildSaveSearchParams() {
        let {savedSearchName, searchUrl} = getSearchNameAndUrl();

        ctrl.searchName = savedSearchName;
        ctrl.searchUrl = searchUrl;

        return {
            alertEmail: ctrl.userEmail,
            savedSearchName,
            alertConfigured: true,
            searchUrl
        };
    }

    function getSearchNameAndUrl() {
        let {
            stockType,
            year,
            make,
            model,
            makeId,
            modelId
        } = pageStateService.get('page.vehicle')[0];

        let savedSearchName = `${stockType} ${year} ${make} ${model} For Sale`;

        let { zipCode } = pageStateService.get('dataProducts') || false;

        if (zipCode) {
            savedSearchName += ` Near ${zipCode}`;
        }

        let searchUrl = historyStateService.referrer() || false;

        if (!searchUrl) {
            let { recentSearches } = JSON.parse(localStorageService.getItem('Cars.history'));

            if (recentSearches[0]) {
                searchUrl = `${$window.location.origin}/${recentSearches[0].url}`;
            } else {
                searchUrl = `${$window.location.origin}/for-sale/search-results.action/?mkId=${makeId}&mdId=${makeId}`;

                let stockTypeId = stockType === 'Used'
                    ? '28881'
                    : stockType === 'New'
                        ? '28880'
                        : false;

                let cpoId = stockType === 'CPO'
                    ? '28444'
                    : false;

                if (stockTypeId) {
                    searchUrl += `&stkTypId=${stockTypeId}`;
                }
                if (cpoId) {
                    searchUrl += `&cpoId=${cpoId}`;
                }
                if (zipCode) {
                    searchUrl += `&zc=${zipCode}`;
                }
            }
        }

        return {savedSearchName, searchUrl};
    }

    function getUserEmail () {
        let userEmail = '';

        if (
            localStorageService.getItem('cars.userSummary') &&
            JSON.parse(localStorageService.getItem('cars.userSummary')).email !== '' &&
            JSON.parse(localStorageService.getItem('cars.userSummary')).email !== 'null'
        ) {
            userEmail = JSON.parse(localStorageService.getItem('cars.userSummary')).email;
        } else if (
            localStorageService.getItem('cars.alertEmail') &&
            localStorageService.getItem('cars.alertEmail') !== '' &&
            localStorageService.getItem('cars.alertEmail') !== 'null'
        ) {
            userEmail = localStorageService.getItem('cars.alertEmail');
        } else if (
            localStorageService.getItem('Cars.emailFormData') &&
            JSON.parse(localStorageService.getItem('Cars.emailFormData')).email !== '' &&
            JSON.parse(localStorageService.getItem('Cars.emailFormData')).email !== 'null'
        ) {
            userEmail = JSON.parse(localStorageService.getItem('Cars.emailFormData')).email;
        }

        return userEmail;
    }

    function cancelTimer() {
        if (ctrl.timer) {
            $timeout.cancel(ctrl.timer);
        }
    }

    function setTimer() {
        cancelTimer();
        ctrl.timer = $timeout(() => {
            displayModal();
            pageStateService.push('event', {eventName: 'abandon-alert-shown-inactive'}, false);
        }, 30000);
    }

    function cancelCapture() {
        cancelTimer();

        ctrl.eventCaptured = true;
        ctrl.inputEvents.forEach(event => $window.removeEventListener(event, ctrl.throttledHandler));
        $rootScope.$emit('abandonPageCaptured');
    }

    function displayModal() {
        sessionStorageService.setItem('vdpAbandonDoNotShow', true);

        cancelCapture();
        modalService.get(ctrl.abandonModalId).open();
    }
}

controller.$inject = [
    '$rootScope',
    '$window',
    '$timeout',
    '$attrs',
    '$cookies',
    'viewport',
    'localStorageService',
    'sessionStorageService',
    'modalService',
    'consumerProfileService',
    'pageStateService',
    'historyStateService',
    'activeTestService'
];

export default controller;
